import React from 'react';
import '../styles/SuccessModal.css';

const SuccessModal = ({ isOpen, title, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="success-modal-overlay">
      <div className="success-modal-container">
        <div className="success-modal-header">
          <h2>{title}</h2>
        </div>
        <div className="success-modal-body">
          <div className="success-icon">✓</div>
          <p>{message}</p>
        </div>
        <div className="success-modal-footer">
          <button className="btn-ok" onClick={onClose}>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
